/* eslint-disable */
export default {
  matched: '匹配',
  other: '其他',
  associated: '已关联项目',
  foundFromServer: '从 {appName} 中找到',
  recently: '最近',
  additionalLabelAccount: '帐户：{displayName}',
  additionalLabelContact: '联系人：{displayName}',
  notFound: '无',
} as const;

// @key: @#@"matched"@#@ @source: @#@"Matched"@#@
// @key: @#@"other"@#@ @source: @#@"Other"@#@
// @key: @#@"associated"@#@ @source: @#@"Associated"@#@
// @key: @#@"foundFromServer"@#@ @source: @#@"Found from {appName}"@#@
// @key: @#@"recently"@#@ @source: @#@"Recent"@#@
// @key: @#@"additionalLabelAccount"@#@ @source: @#@"Account: {displayName}"@#@
// @key: @#@"additionalLabelContact"@#@ @source: @#@"Contact: {displayName}"@#@
// @key: @#@"notFound"@#@ @source: @#@"N/A"@#@
